import { Image } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";

export interface IRunwayDetailsProps {
  headwind: number;
  activeRunway: string;
  crosswind: number;
  crosswindDirection: string;
  crosswindPercentage: number;
  runwayImg?: string;
}

const RunwayDetails: React.FunctionComponent<IRunwayDetailsProps> = ({
  headwind,
  crosswind,
  crosswindDirection,
  crosswindPercentage,
  runwayImg,
  activeRunway,
}) => {
  const styles = useStyles();
  return (
    <div className="" data-testid="runway-details">
      <div className={styles.imageWrapper}>
        <div className={`${styles.overlayTextTop} `}>
          <div className="">
            Crosswind({activeRunway}): <br />
            {crosswind} kts {crosswindPercentage}% <br />
          </div>
          {crosswind !== 0 ? (
            crosswindDirection === "ltr" ? (
              <HorizontalArrow direction="right" />
            ) : (
              <HorizontalArrow direction="left" />
            )
          ) : (
            <span style={{ display: "inline-block", width: 120, height: 20 }} />
          )}
        </div>
        <div className={`${styles.overlayText} d-flex align-items-center`}>
          <div className="pt-5">
            {headwind >= 0
              ? `Headwind(${activeRunway})`
              : `Tailwind(${activeRunway})`}
            :
            <br />
            <span className="pl-4">{Math.abs(headwind)} kts</span>
          </div>

          {headwind !== 0 ? (
            <div className="ms-2">
              <VerticalArrow direction={headwind >= 0 ? "down" : "up"} />
            </div>
          ) : (
            <div className="ms-2" style={{ width: 20, height: 120 }} />
          )}
        </div>

        <Image
          src={runwayImg}
          className={styles.runwayImage}
          data-testid="runway-img"
        />
      </div>
    </div>
  );
};
const HorizontalArrow = ({
  direction = "right",
  width = 120,
  height = 20,
}: {
  direction?: "left" | "right";
  width?: number;
  height?: number;
}) => {
  const isLeft = direction === "left";

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ transform: isLeft ? "scaleX(-1)" : undefined }}
    >
      <line
        x1="0"
        y1={height / 2}
        x2={width - 12}
        y2={height / 2}
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <polygon
        points={`${width - 12},${height / 2 - 8} ${width},${height / 2} ${
          width - 12
        },${height / 2 + 8}`}
        fill="black"
      />
    </svg>
  );
};
const VerticalArrow = ({
  direction = "down",
  height = 120,
  width = 20,
}: {
  direction?: "up" | "down";
  height?: number;
  width?: number;
}) => {
  const isUp = direction === "up";

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ transform: isUp ? "scaleY(-1)" : undefined }}
    >
      <line
        x1={width / 2}
        y1="0"
        x2={width / 2}
        y2={height - 12}
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <polygon
        points={`${width / 2 - 8},${height - 12} ${width / 2},${height} ${
          width / 2 + 8
        },${height - 12}`}
        fill="black"
      />
    </svg>
  );
};
export default RunwayDetails;
const useStyles = makeStyles({
  imageWrapper: {
    position: "relative",
    display: "inline-block",
  },
  overlayText: {
    position: "absolute",
    top: "60%",
    right: "200px",
    transform: "translateY(-50%)",
    fontSize: "18px",
    fontWeight: 600,
    color: "#000",
    pointerEvents: "none",
    whiteSpace: "nowrap",
  },
  overlayTextTop: {
    position: "absolute",
    left: "120px",
    transform: "translateY(0%)",
    fontSize: "18px",
    fontWeight: 600,
    color: "#000",
    pointerEvents: "none",
    whiteSpace: "nowrap",
  },
  runwayImage: {
    maxWidth: "none",
    maxHeight: "none",
    paddingTop: "20px",
    width: "360px",
    height: "300px",
    flexShrink: 0,
    display: "block",
  },
});
